import { createDecorator } from 'vue-class-component';
import { mapGetters } from 'vuex';

export function MapGetters(namespace: string, states: Array<string>) {
  return createDecorator(options => {
    if (!options.computed) options.computed = {};
    Object.assign(options.computed, mapGetters(namespace, states));
  });
}
